import React from 'react'
import "./AboutDesc.css"
const AboutDesc = () => {
  return (
    <div className="abt-desc">
      <h1>About Me</h1>
      <p>
        I'm a Software Engineer, currently motivated to build <br />
        <b> Full Stack Web/App applications</b>, having a passion for building
        interactive, functional, and user-friendly web applications in a
        professional way.
        <br />
        I'm always eager to learn new technologies & techniques and up for a
        challenge. Currently I'm working with advance frameworks / technologies
        like <b>ReactJS, NextJS, Strapi CMS, Supabase, Prisma ORM, NodeJS, Express, MongoDB, PostgreSQL, MySQL, Firebase, Tailwind CSS, Shadcn UI, etc.</b>
      </p>
    </div>
  );
}

export default AboutDesc